<template>
  <!-- 首页 -->
  <div class="home">
    <BannerSwiper></BannerSwiper>
    <!-- 教育 -->
    <div class="service-education">
      <Title title="植根教育	服务教育"></Title>
      <ModuleDesc desc="让更多的孩子得到更好的教育" desc2="让更多的教师得到更好的提高，让更多的学校得到更好的发展"></ModuleDesc>
      <div class="service-education-content">
        <div class="service-item" v-for="(item, index) in serviceList" :key="index">
          <img class="item-img" :src="item.imgUrl" alt="">
          <p>{{item.num}}</p>
          <p>{{item.desc}}</p>
        </div>
      </div>
    </div>
    <!-- 公益事业 -->
    <div class="charity-wrap">
      <Title title="公益事业"></Title>
      <ModuleDesc desc="我们一直在行动"></ModuleDesc>
      <div class="charity-content">
        <div class="charity-item" v-for="(item, index) in charityList" :key="index">
          <img class="charity-img" :src="item.imgUrl" alt="">
          <div class="charity-title">
            <span>{{item.title}}</span>
            <img class="charity-icon" :src="item.iconUrl" alt="">
          </div>
          <div class="charity-mask">{{item.desc}}</div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="edu-solution">
      <Title title="智慧教育解决方案"></Title>
      <ModuleDesc desc="推动教育优质均衡和高质量发展"></ModuleDesc>
      <div class="edu-solution-wrap">
        <div class="solution-item solution-item1">
          <img src="../../assets/images/homeSolution/homesol_1.png" alt="">
          <p>基于“三个课堂”的区域教育优质均衡解决方案</p>
        </div>
        <div class="solution-item-wrap">
          <div style="margin-right:12px;">
            <div class="solution-item solution-item2">
              <img src="../../assets/images/homeSolution/homesol_2.png" alt="">
              <p>数据驱动下的<br/>智慧课堂精准教学</p>
            </div>
            <div class="solution-item solution-item3">
              <img src="../../assets/images/homeSolution/homesol_3.png" alt="">
              <p>基于“专递课堂”的<br/>教育均衡解决方案</p>
            </div>
          </div>
          <div style="margin-right:12px;">
            <div class="solution-item solution-item4">
              <img src="../../assets/images/homeSolution/homesol_4.png" alt="">
              <p>“双减”背景下的<br/>智慧作业解决方案</p>
            </div>
            <div class="solution-item solution-item5">
              <img src="../../assets/images/homeSolution/homesol_5.png" alt="">
              <p>基于“名师课堂”的<br/>教研共同体应用方案</p>
            </div>
          </div>
          <div>
            <div class="solution-item solution-item6">
              <img src="../../assets/images/homeSolution/homesol_6.png" alt="">
              <p>基于“名校网络课堂”的<br/>优质教育共建共享方案</p>
            </div>
            <div class="solution-item solution-item7">
              <img src="../../assets/images/homeSolution/homesol_7.png" alt="">
              <p>基于考试数据的<br/>教学评价及改进方案</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作案例 -->
    <div class="service-case">
      <Title title="合作案例"></Title>
      <ModuleDesc desc="赋能学校	赋能老师"></ModuleDesc>
      <div class="service-case-swiper">
        <swiper ref="swiper" :options="swiperOption">
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_1.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_2.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_3.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_4.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_5.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_6.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_7.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_8.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_9.png" alt=""></swiper-slide>
          <swiper-slide><img class="case-item" src="../../assets/images/homeCase/case_10.png" alt=""></swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <RightNav></RightNav>
  </div>
</template>
<script>
import BannerSwiper from './components/BannerSwiper.vue'
import Title from './components/ModuleTitle.vue'
import ModuleDesc from './components/ModuleDesc.vue';
import RightNav from './components/RightNav.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  data() {
    return {
      serviceList: [{
        imgUrl: require('../../assets/images/s_1.png'),
        num: '20+年',
        desc: '教育产业经验'
      }, {
        imgUrl: require('../../assets/images/s_3.png'),
        num: '200+',
        desc: '业务覆盖城市'
      }, {
        imgUrl: require('../../assets/images/s_2.png'),
        num: '4000+',
        desc: '合作学校'
      }, {
        imgUrl: require('../../assets/images/s_4.png'),
        num: '300000+',
        desc: '教师受益'
      }, {
        imgUrl: require('../../assets/images/s_5.png'),
        num: '3000000+',
        desc: '学生受益'
      }],
      charityList: [{
        imgUrl: require('../../assets/images/charity_1.png'),
        iconUrl: require('../../assets/images/charity_11.png'),
        title: '外交部驻外随居子女远程教育',
        desc: '自2011年开始，与外交部干部司签约合作，为200多个中国驻外使领馆（含代表团）的随居子女，提供优质的国内同步学习服务。'
      }, {
        imgUrl: require('../../assets/images/charity_2.png'),
        iconUrl: require('../../assets/images/charity_22.png'),
        title: '中国华文教育基金会教师讲堂',
        desc: '2013年，与统战部（原国侨办）下属中国华文教育基金会合作，公益服务全球华文学校，8年多以来，服务了90多个国家1500多所华校，先后培训过数十万海外华文教师。'
      }, {
        imgUrl: require('../../assets/images/charity_3.png'),
        iconUrl: require('../../assets/images/charity_33.png'),
        title: '民盟远程教育烛光行动',
        desc: '2011年，与民盟中央签署远程教育烛光行动公益合作协议。为偏远地区和欠发达地区的教师提供智慧教育平台，有效加强了广大一线教师教育教学能力及综合素质。2016年，启动“民盟远程教育烛光行动-千校计划”，积极推进“互联网+教育”的发展，为深入推进义务教育均衡发展做出更大贡献。'
      }],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        direction: 'horizontal',
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        speed: 1000,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  components: {
    BannerSwiper,
    Title,
    ModuleDesc,
    Swiper,
    SwiperSlide,
    RightNav
  }
}
</script>
<style lang="scss" scoped>
.home {
  .service-education {
    margin-top: 160px;
    .service-education-content {
      display: flex;
      justify-content: center;
      margin: 0 auto;
      margin-top: 92px;
      // width: 1080px;
      max-width: 100%;
      .service-item {
        width: 192px;
        height: 205px;
        background: #FFFFFF;
        color: #595757;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
        color: #595757;
        line-height: 30px;
        padding-top: 32px;
        margin-right: 28px;
        .item-img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-bottom: 24px;
        }
      }
      .service-item:last-child {
        margin-right: 0;
      }
      .service-item:hover {
        margin-top: -22px;
        box-shadow: 0px 14px 73px 0px rgba(116, 116, 116, 0.19);
      }
    }
  }
  .charity-wrap {
    margin-top: 204px;
    .charity-content {
      display: flex;
      justify-content: center;
      margin-top: 82px;
      .charity-item {
        position: relative;
        width: 350px;
        background: #FFFFFF;
        box-shadow: 6px 7px 10px 0px rgba(61, 61, 61, 0.25);
        border-radius: 15px;
        overflow: hidden;
        margin-right: 46px;
        .charity-img {
          width: 350px;
          height: 308px;
        }
        .charity-title {
          position: relative;
          padding: 50px 0 44px;
          text-align: center;
          font-size: 22px;
          font-weight: 500;
          color: #3E3A39;
          line-height: 22px;
          .charity-icon {
            background: #fff;
            position: absolute;
            width: 62px;
            height: 62px;
            top: -30px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50%;
            box-shadow: 0px 3px 4px 0px rgba(2, 48, 95, 0.35);
          }
        }
        .charity-mask {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, .5);
          display: none;
          padding: 32px 30px 52px;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
        }
      }
      .charity-item:last-child {
        margin-right: 0;
      }
      .charity-item:hover {
        .charity-mask {
          display: block;
        }
      }
    }
  }
  .edu-solution {
    margin-top: 224px;
    text-align: center;
    &-wrap {
      width: 1198px;
      max-width: 100%;
      margin: 0 auto;
      margin-top: 124px;
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
      text-align: left;
      .solution-item {
        img {
          width: 100%;
          height: 100%;
        }
        p {
          position: absolute;
          left: 20px;
          bottom: 30px;
        }
      }
      .solution-item:hover {
        transition: .3s;
        font-size: 28px;
        line-height: 32px;
      }
      .solution-item1 {
        width: 100%;
        height: 268px;
        position: relative;
        margin-bottom: 12px;
        p {
          bottom: 14px;
        }
      }
      .solution-item-wrap {
        display: flex;
        width: 100%;
        .solution-item2 {
          width: 392px;
          height: 438px;
          position: relative;
        }
        .solution-item3 {
          width: 392px;
          height: 304px;
          margin-top: 12px;
          position: relative;
        }
        .solution-item4 {
          width: 392px;
          height: 304px;
          position: relative;
        }
        .solution-item5 {
          width: 392px;
          height: 438px;
          margin-top: 12px;
          position: relative;
        }
        .solution-item6 {
          width: 392px;
          height: 438px;
          position: relative;
        }
        .solution-item7 {
          width: 392px;
          height: 304px;
          margin-top: 12px;
          position: relative;
        }
      }
    }
  }
  .service-case {
    margin-top: 224px;
    margin-bottom: 232px;
    .service-case-swiper {
      width: 1168px;
      margin: 0 auto;
      position: relative;
      margin-top: 110px;
      .case-item {
        width: 366px;
        height: 272px;
      }
    }
  }
}
</style>
<style lang="scss">
.service-case-swiper {
  .swiper-container {
    position: static;
    .swiper-button-prev, .swiper-button-next {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #E6E6E6;
      color: #fff;
    }
    .swiper-button-prev:after, .swiper-button-next:after {
      font-size: 24px;
      font-weight: 600;
    }
    .swiper-button-prev {
      left: -70px;
    }
    .swiper-button-next {
      right: -70px;
    }
  }
}
</style>